import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  Stack
} from '@mui/material';

import { CloseOutlined } from '@mui/icons-material';

import {
  cancelButtonSx,
  dialogActionsSx,
  dialogCloseButtonSx,
  dialogContentSx,
  dialogFormSx,
  dialogHeaderSx,
  dialogPaperSx,
  dialogSubtitleSx,
  dialogTitleSx,
  dialogTitleTextSx,
  saveButtonSx
} from './styles';

import {
  dialogHeaderStyles,
  textFieldSx,
  menuProps
} from '../../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../../Common/components/CommonDialogActions';

const EditProviderModal = ({ data, onClose, onSave, open }) => {
  const [form, setForm] = useState(data);

  useEffect(() => {
    if (open) {
      setForm(data);
    }
  }, [data, open]);

  const handleChange = field => event => {
    setForm(previousForm => ({
      ...previousForm,
      [field]: event.target.value
    }));
  };

  const handleSave = () => {
    onSave(form);
  };

  const isSaveDisabled =
    !form.licenseNumber?.trim() ||
    !form.individualNpi?.trim() ||
    !form.specialtyTaxonomy?.trim() ||
    !form.deaNumber?.trim();

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: dialogPaperSx
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Profile
          </Typography>
          <Typography sx={dialogHeaderStyles.subtitle}>
            View and update your personal profile information.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}>
          <CloseOutlined sx={{ fontSize: 22 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 2 }}>
        <Stack spacing={1.6} sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="License Number"
            onChange={handleChange('licenseNumber')}
            size="small"
            sx={textFieldSx}
            value={form.licenseNumber || ''}
          />

          <TextField
            fullWidth
            label="Individual NPI"
            onChange={handleChange('individualNpi')}
            size="small"
            sx={textFieldSx}
            value={form.individualNpi || ''}
          />

          <TextField
            fullWidth
            label="Provider Specialty Taxonomy"
            onChange={handleChange('specialtyTaxonomy')}
            size="small"
            sx={textFieldSx}
            value={form.specialtyTaxonomy || ''}
          />

          <TextField
            fullWidth
            label="DEA Number"
            onChange={handleChange('deaNumber')}
            size="small"
            sx={textFieldSx}
            value={form.deaNumber || ''}
          />
        </Stack>
      </DialogContent>
      <CommonDialogActions
        onCancel={onClose}
        onSubmit={handleSave}
        submitText="Save"
        disabled={isSaveDisabled}
      />
    </Dialog>
  );
};

EditProviderModal.propTypes = {
  data: PropTypes.shape({
    deaNumber: PropTypes.string,
    individualNpi: PropTypes.string,
    licenseNumber: PropTypes.string,
    specialtyTaxonomy: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default EditProviderModal;
